import React from 'react';
import { __ } from 'js/util';
import { feedbackTypes } from '..';
import { CloseButton } from '../../CloseButton';

export function FeedbackTypeStep({ onFeedbackTypeChanged }) {
  return (
    <>
      <header>
        <span className="text-xl text-white dark:text-zinc-100 leading-6">{__('Deixe o seu feedback')}</span>
        <CloseButton />
      </header>
      <div className="flex py-8 gap-2 w-full">
        {
          Object.entries(feedbackTypes).map(([key, value]) => (
            <button
              key={key}
              className="bg-primary-50 text-zinc-100 rounded-lg py-5 w-24 flex-1 flex flex-col items-center gap-2 border-2 border-transparent hover:border-brand-500 focus:border-brand-500 focus:outline-none"
              type="button"
              onClick={() => onFeedbackTypeChanged(key)}
            >
              <img src={value.image.source} alt={value.image.alt ?? ''} />
              <span className="text-primary-900">{__(value.title)}</span>
            </button>
          ))
        }
      </div>
    </>
  );
}
